"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyGetFromCountry = void 0;
const currencies_1 = require("./currencies");
const currency_iso_country_iso_mapping_1 = require("./currency-iso-country-iso-mapping");
const currencyGetFromCountry = (countryIso) => {
    var _a;
    const currencyIso = (_a = currency_iso_country_iso_mapping_1.currencyIsoCountryIsoMapping.find(i => i.countryIso === countryIso)) === null || _a === void 0 ? void 0 : _a.currencyIso;
    if (currencyIso) {
        return currencies_1.currenciesAll.find((c) => currencyIso === c.iso);
    }
    return currencies_1.currenciesAll.find((c) => c.iso === "EUR");
};
exports.currencyGetFromCountry = currencyGetFromCountry;
//# sourceMappingURL=currency-get-from-country.js.map